import React from 'react';

import { Auth, I18n } from 'aws-amplify';

import {
  ConfirmSignUp,
} from 'aws-amplify-react';

import {
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  InputRow,
  ActionRow,
  MessageRow,
  Button,
  Space,
  Link
} from 'aws-amplify-react';

import LogoArea from './logoarea.js';
import Stepper from './stepper.js';
import LapDialog from '../util/laplaceDialog.js';
import getHrefByLocaleLaplaceidQa from '../util/getHrefByLocale.js';

export default class MyConfirmSignUp extends ConfirmSignUp {
  constructor (props) {
    super(props);
    this.state = {
      errorStr: "",
      open: false,
      isDisabled: true,
      resendErrOpen: false,
    };
    this.inputs = {};
  }
  toClose = () => {
    this.setState({
      open: false
    });
  }
  resendErrClose = () => {
    this.setState({
      resendErrOpen: false
    });
  }
  toSecond = (username, pw) => {
    Auth.signIn(username, pw).then((user) => {
      const userData = {
        username: username,
        pw: pw
      };
      const datum = {
        user: user,
        userData: userData,
      };
      Auth.signOut().then(()=>this.changeState('secondSignUp', datum));
    }).catch(err=>{
      console.log('toSecond err is');
      console.log(err);
      if (err.hasOwnProperty('message')) {
        if ('Incorrect username or password.' === err.message) {
          // 確認コード未入力の状態で、F5したときにログイン画面から間違ったパスワードでもログインできる
          // もし不正なログインな場合はもう一度パスワード確認しなおす
          this.changeState('checkpass', username);
        }
      }
    });
  }

  handleInputChange(evt) {
    const { name, value } = evt.target;
    this.inputs[name] = value;
    let error = '';
    let buttonState = this.state.isDisabled;
    if (name === 'code') {
      if (value.match(/([^0-9])+/)) {
        error = I18n.get('Invalid verification code provided, please try again.');
        buttonState = true;
      } else if (value === '') {
        buttonState = true;
      } else {
        buttonState = false;
      }
      this.setState({
        errorStr: error,
        isDisabled: buttonState
      })
    }
  }

  confirm() {
    const username = this.props.authData.username || this.usernameFromAuthData() || this.inputs.username;
    const { code } = this.inputs;
    if (!Auth || typeof Auth.confirmSignUp !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.confirmSignUp(username, code)
    .then(() => {
      this.toSecond(username, this.props.authData.pw);
    }).catch(err => {
      const errMessage = err.message ? err.message : err;
      if (errMessage === "User cannot be confirm. Current status is CONFIRMED") {
        this.toSecond(username, this.props.authData.pw);
      } else {
        this.setState({
          errorStr : I18n.get(errMessage),
        });
      }
    }).catch(err=>{
      console.log('confirm err is');
      console.log(err);
    });
  }
  getErrorMessage = (err) => {
    const {code, message} = err;
    if (message)
      return message;
    if (code)
      return code;
    if (typeof err === 'string')
      return err;
    return '';
  }
  resend() {
    const username = this.usernameFromAuthData() || this.inputs.username;
    Auth.resendSignUp(username).then(() => {
      this.setState({
        open:true
      });
    }).catch(err => {
      const tmpstr = this.getErrorMessage(err);
      console.log('lap confirm resend err');
      console.log(err);
      
      this.setState({
        resendErrStr: I18n.get(tmpstr),
        resendErrOpen:true
      });
    });
  }

  showComponent(theme) {
    const username = this.props.authData.username || this.usernameFromAuthData() || this.inputs.username;
    return (
      <div className="loginContainer">
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
        <SectionHeader theme={theme}>
        {I18n.get('Confirm Sign Up')}
        </SectionHeader>
        <Stepper nowStatus="50%" />
        <SectionBody theme={theme}>
          <div className="fontSizeSmall colNatural01">
            { username? <MessageRow>{username}<br />{I18n.get('The Verification Code was sent. Enter the 6 digit verification code described in the mail body and send it.')}
              </MessageRow>
              : <InputRow
                placeholder={I18n.get('Username')}
                theme={theme}
                key="username"
                name="username"
                onChange={this.handleInputChange}
              />
            }
          </div>
          <label className="loginLabel">{I18n.get('Code')}</label>
          <InputRow
            autoFocus
            placeholder={I18n.get('Code')}
            theme={theme}
            key="code"
            name="code"
            autoComplete="off"
            onChange={this.handleInputChange}
          />
          <p className='errorText'>{this.state.errorStr}</p>
          <ActionRow theme={theme}>
            <div className="confirmCode">
              <Button style={theme.loginLargeButton} theme={theme} onClick={this.confirm} disabled={this.state.isDisabled}>
                {I18n.get('Confirm')}
              </Button>
            </div>
            <Space theme={theme} />
          </ActionRow>
        </SectionBody>
        <SectionFooter theme={theme}>
          <div className="loginCodecheckFooter textLeft">
            <p className="fontSizeSmall">{I18n.get('If you can not receive verification code, you can try to resend.')}<br />
              <Link theme={theme} onClick={this.resend}>{I18n.get('Resend Code')}</Link>
            </p>
            {getHrefByLocaleLaplaceidQa(theme)}
          </div>
        </SectionFooter>
        </FormSection>
        <LapDialog contentText={I18n.get('The Verification Code was resent.')} open={this.state.open} toClose={this.toClose} />
        <LapDialog contentText={this.state.resendErrStr} open={this.state.resendErrOpen} toClose={this.resendErrClose} />
      </div>
    )
  }
}
